import { Grid } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

import "./coverage.css";
import { PLAN_NAMES, PLAN_NAMES_ICI } from "../../../../../../constants/planNames";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import { FormControl } from "@mui/material";
import { useCallback } from "react";

/* eslint-disable react/prop-types */
const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
	// eslint-disable-next-line
})((props) => <Checkbox color="default" {...props} />);

const Coverage = ({ coverage, handleCoverageChange, planName, handlePaste, columns, coverageType }) => {
	const queryGroupNumber = useRouteParam("gn");
	const handleCheckboxChange = useCallback(
		// eslint-disable-next-line
		(event) => {
			// setState({ ...state, [event.target.name]: event.target.checked });
			handleCoverageChange(event, "premium_without_dependent");
		},
		[handleCoverageChange]
	);

	console.log("ok", coverage);
	return (
		<div className="coverage">
			<div className="coverage-details">
				<Grid container justifyContent="center" className="column-header-row">
					{coverageType !== "employers_contribution" &&
						Object.entries(coverage)
							.filter(([coverageKey]) => coverageKey == "premium_without_dependent")
							.map(([coverageKey, coverageValue], index) => {
								return (
									<Grid container spacing={1} className="pf-label" key={coverageKey + index}>
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="pf-label-text">Premium Without Dependent?</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											<FormControl variant="outlined">
												<GreenCheckbox
													checked={coverageValue}
													onChange={handleCheckboxChange}
													name="premium_without_dependent"
												/>
											</FormControl>
										</Grid>
									</Grid>
								);
							})}
					{columns.map((column, index) => {
						return column === "Premium Type" && coverageType === "employers_contribution" ? (
							""
						) : (
							<Grid
								item
								xl={columns.length > 6 ? (index <= 2 ? 1 : 2) : 3}
								lg={columns.length > 6 ? (index <= 2 ? 1 : 2) : 3}
								key={index}
								className={index === columns.length - 1 ? " " : "column-header-container"}
								style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
							>
								<div style={{ display: "inline-flex" }}>
									<div className="column-header ">{column}</div>
								</div>
							</Grid>
						);
					})}
					<div className="column-bottom-border"></div>

					{Object.entries(coverage)
						.filter(([coverageKey]) => coverageKey != "premium_without_dependent")
						.map(([coverageKey, coverageDetails], index) => {
							return (
								// coverageType === "employers_contribution" ||
								// 	// (planName === PLAN_NAMES.group_short_term_disability && coverageKey === "EE") ||
								// 	// (planName === PLAN_NAMES.group_long_term_disability_class2 && coverageKey === "EE") ||
								// 	// (planName === PLAN_NAMES.health_plan &&
								// 	// 	(Number(queryGroupNumber) === 300 ? true : coverageKey !== "ED")) ||
								// 	// (planName === PLAN_NAMES.clinic_card && (coverageKey === "ED" || coverageKey === "EE")) ||
								// 	// planName === PLAN_NAMES_ICI.ici_group_long_term_disability
								// 	true ? (
								<Grid container justifyContent="center" className="column-item-row" key={index}>
									<Grid
										item
										xl={columns.length > 6 ? 1 : 3}
										lg={columns.length > 6 ? 1 : 3}
										key={index}
										className={index === columns.length - 1 ? "" : "column-item-container"}
										style={{
											flex: 1,
											display: "flex",
											alignItems: "center",
											justifyContent: "center"
										}}
									>
										<div style={{ display: "inline-flex" }}>
											{/* {planName === "group_short_term_disability" && coverageKey === "EE" ? (
											<div className="column-item">{coverageKey}</div>
										) : ( */}
											<div className="column-item">
												{coverageKey[0].toUpperCase() + coverageKey.slice(1)}
											</div>
										</div>
									</Grid>
									{Object.entries(coverageDetails).map(([key, value], index) => {
										{
											return key === "premium_type" &&
												coverageType === "employers_contribution" ? (
												""
											) : (
												<Grid
													item
													xl={columns.length > 6 ? (index <= 1 ? 1 : 2) : 3}
													lg={columns.length > 6 ? (index <= 1 ? 1 : 2) : 3}
													key={index}
													className={
														index === columns.length - 1 ? "" : "column-item-container"
													}
													style={{
														flex: 1,
														display: "flex",
														alignItems: "center",
														justifyContent: "center"
													}}
												>
													<div style={{ display: "inline-flex" }}>
														<div className="column-item" style={{ padding: "0px 5px" }}>
															{key === "premium_type" ? (
																<div className="select-column-container">
																	<select
																		name="premium_type"
																		value={
																			coverageType === "employers_contribution"
																				? "FIXED"
																				: coverageDetails[key]
																		}
																		className="select-column-item"
																		// prettier-ignore
																		onChange={event =>
																		handleCoverageChange(event, coverageKey)
																	}
																		style={{ padding: "0px 5px", width: "100%" }}
																		disabled={
																			coverageType === "employers_contribution" ||
																			coverage[coverageKey].active === false
																				? true
																				: false
																		}
																	>
																		<option value=""></option>
																		<option value="FIXED">Fixed</option>
																		<option value="PERCENTAGE">Percentage</option>
																	</select>
																</div>
															) : key === "active" ? (
																<GreenCheckbox
																	checked={value}
																	// prettier-ignore
																	onChange={event =>
																	handleCoverageChange(event, coverageKey)
																}
																	name={key}
																/>
															) : (
																<input
																	name={key}
																	value={value}
																	// prettier-ignore
																	onChange={event =>
																	handleCoverageChange(event, coverageKey)
																}
																	// prettier-ignore
																	onPaste={event => handlePaste(event)}
																	style={{ width: "100%" }}
																	disabled={
																		(coverage[coverageKey].premium_type ===
																			"FIXED" &&
																			(key.endsWith("_maximum_premium") ||
																				key.endsWith("_minimum_premium"))) ||
																		// (key === "monthly_maximum_premium" ||
																		// 	key === "weekly_maximum_premium" ||
																		// 	key === "monthly_minimum_premium" ||
																		// 	key === "weekly_minimum_premium")
																		coverage[coverageKey].active === false
																			? true
																			: false
																	}
																/>
															)}
														</div>
													</div>
												</Grid>
											);
										}
									})}
								</Grid>
							);
							// ) : (
							// 	""
							// );
						})}
				</Grid>
			</div>
		</div>
	);
};

export default Coverage;
